<template>
  <component
    v-if="node && node.child"
    :is="node['html-tag'] ? node['html-tag'] : 'div'"
    :class="node.class ? node.class : ''"
  >
    <RecursiveLevelSection
      :languageCodeList="languageCodeList"
      :entityData="entityData"
      :dataSeriesParametersOverride="dataSeriesParametersOverride"
      :node="node.child"
      :isClientPage="isClientPage"
    >
    </RecursiveLevelSection>
  </component>
  <component
    v-else
    :is="node && node.component ? node.component : 'div'"
    :sectionDisplay="node && node.sectionDisplay ? node.sectionDisplay : {}"
    :section="node && node.section ? node.section : {}"
    :language="node && node.language ? node.language : 'en'"
    :data="node && node.data ? node.data : {}"
    :entityId="node && node.entityId ? node.entityId : null"
    :entityData="entityData ? entityData : null"
    :dataSeriesParametersOverride="
      dataSeriesParametersOverride ? dataSeriesParametersOverride : null
    "
    :dashboardOnly="node && node.dashboardOnly ? node.dashboardOnly : null"
    :languageCodeList="languageCodeList"
    :isClientPage="isClientPage"
  >
  </component>
</template>

<script>
export default {
  name: 'RecursiveLevelSection',
  props: [
    'node',
    'entityData',
    'dataSeriesParametersOverride',
    'languageCodeList',
    'isClientPage',
  ],
  components: {
    ParagraphComponent: () =>
      import('@/components/dynamic-components/ParagraphComponent'),
    ImageComponent: () =>
      import('@/components/dynamic-components/ImageComponent'),
    FormComponent: () =>
      import('@/components/dynamic-components/FormComponent'),
    AnalyticsComponent: () =>
      import('@/components/dynamic-components/AnalyticsComponent'),
    MenuComponent: () =>
      import('@/components/dynamic-components/MenuComponent'),
    CompositeComponent: () =>
      import('@/components/dynamic-components/CompositeComponent'),
    CompositeTabComponent: () =>
      import('@/components/dynamic-components/CompositeTabComponent'),
    CallToActionComponent: () =>
      import('@/components/dynamic-components/CallToActionComponent'),
    HtmlContentComponent: () =>
      import('@/components/dynamic-components/HtmlContentComponent'),
    FileComponent: () =>
      import('@/components/dynamic-components/FileComponent'),
    StaticComponent: () =>
      import('@/components/dynamic-components/StaticComponent'),
    TableComponent: () =>
      import('@/components/dynamic-components/TableComponent'),
    PageLoaderComponent: () =>
      import('@/components/dynamic-components/PageLoaderComponent'),
  },
};
</script>
